<template>
  <div class="upload">

    <template v-if="more">

      <input type="file" @change="upload($event)" :style="'z-index:'+z_index" multiple="multiple" />
    </template>

    <template v-else>

      <input type="file" @change="upload($event)" :style="'z-index:'+z_index" />

    </template>

    <slot>
      <el-button :type='type' :size='size'>{{buttonTitle}}</el-button>
    </slot>


  </div>
</template>

<script>
  export default {
    name: "Upload",
    data() {
      return {


      }
    },
    methods: {

      upload(event) {

        // return console.log(event.target.files);


        // return new Promise((success,fail)=>{


        // console.log(event.target.files);

        if(event.target.files.length<=0) return;

        for (let i in event.target.files) {

          let size = event.target.files[i].size;

          if (size > this.maxSize) return this.$alert('超出最大上传大小', '错误', {
            confirmButtonText: '确定',

          });

        }


        if (this.more) {


          this.uploadFileForList(event,{resize:this.resize,maxResizeByte:this.maxResizeByte}).then((re) => {


            // success(re);

            this.$emit('success', re.data, this.customParams);

          });



        } else {

          this.uploadFile(event,{resize:this.resize,maxResizeByte:this.maxResizeByte}).then((re) => {


            // success(re);

            this.$emit('success', re.data[0], this.customParams);

          });


        }




        // });



      }

    },
    created() {

    },
    computed: {

    },
    props: {

      buttonTitle: {
        type: String,
        default: '上传'
      },
      customParams: {
        type: Array,
        default: function() {

          return [];
        }
      },
      type: {
        type: String,
        default: 'primary'

      },
      size: {
        type: String,
        default: 'small'
      },
      z_index: {
        type: [String, Number],
        default: '200'

      },
      /**
       * 多文件上传
       */
      more: {

        type: Boolean,
        default: false

      },
      /**
       * 最大上传大小
       */
      maxSize: {
        type: Number,
        default: 1048576
      },
      /**
       * 裁剪宽度（相当于压缩，高度自定义,0为不裁剪）
       */
      resize:{
        type:Number,
        default:0
      },
      /**
       * 到达某个大小后需要被裁剪(默认100kb)
       */
      maxResizeByte:{
        type:Number,
        default:102400
      }
    }

  }
</script>

<style scoped>
  .upload {
    position: relative;
    width: -webkit-fit-content;

  }

  .upload>input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;

  }
</style>



// WEBPACK FOOTER //
// src/components/common/Upload.vue